import React, {useContext, useState} from "react";
import { Admin, Agency, Blog, Car, Cost, DailyCost, Driver, FullReservation, GlobalUser, Guider, Passenger, Payment, Reservation, ReservationPayment, ReservationPaymentList, Seller, Tour } from "../types/common.types";
import AdminService from "../services/admin.service";
import { startOfToday } from 'date-fns'
import { AdminContextType } from "../types/admin";

const AdminProvider = React.createContext<AdminContextType>(null as any)

export const AdminContext = ({children}: {children: React.ReactNode}) => {
    const getUser = () => {
        const user = localStorage.getItem('admin')
        if (user) {
            return JSON.parse(user)
        } else return null
    }
    // useStates
    // superadmin
    const [isCreateAgencyModalOpen, setIsCreateAgencyModalOpen] = useState(false)
    const [editTourData, setEditTourData] = useState<Partial<Tour>>()
    const [confirmDeleteTourId, setConfirmDeleteTourId] = useState<string>()
    const [confirmDeleteAgencyId, setConfirmDeleteAgencyId] = useState<string>()
    // general
    const [user, setUser] = useState<GlobalUser>(getUser())
    const [tab, setTab] = useState<string>()
    // admin
    const [isCreateTourModalOpen, setIsCreateTourModalOpen] = useState(false)
    const [tourInfoId, setTourInfoId] = useState<string>()
    // create modals
    const [isCreatePassengerModalOpen, setIsCreatePassengerModalOpen] = useState(false)
    const [isCreateSellerModalOpen, setIsCreateSellerModalOpen] = useState(false)
    const [isCreateAdminModalOpen, setIsCreateAdminModalOpen] = useState(false)
    const [isCreateDriverModalOpen, setIsCreateDriverModalOpen] = useState(false)
    const [isCreateGuiderModalOpen, setIsCreateGuiderModalOpen] = useState(false)
    const [isCreateCarModalOpen, setIsCreateCarModalOpen] = useState(false)
    const [isCreateZoneModalOpen, setIsCreateZoneModalOpen] = useState<boolean>(false)
    const [isCreateCostModalOpen, setIsCreateCostModalOpen] = useState<boolean>(false)
    const [isCreatePaymentReservationModalOpen, setIsCreatePaymentReservationModalOpen] = useState<boolean>(false)
    const [createPaymentResId, setCreatePaymentResId] = useState<string>()
    const [createPaymentGroupId, setCreatePaymentGroupId] = useState<string>()
    const [isCreateDailyCostModalOpen, setIsCreateDailyCostModalOpen] = useState<boolean>(false)
    const [createPaymentReservationId, setCreatePaymentReservationId] = useState<string>()
    // list
    const [isListDailyCostsModalOpen, setIsListDailyCostsModalOpen] = useState<boolean>(false)
    const [viewPaymentAgencyId, setViewPaymentAgencyId] = useState<string>()
    const [relationshipAgencyId, setRelationshipAgencyId] = useState<string>()
    const [viewPaymentsData, setViewPaymentsData] = useState<ReservationPayment[]>()
    const [viewPaymentTraspassData, setViewPaymentTraspassData] = useState<Payment[]>()
    const [reservationDetails, setReservationDetails] = useState<FullReservation[]>()
    const [reservationData, setReservationData] = useState<ReservationPaymentList>()
    // assign / register
    const [passengerPlanId, setPassengerPlanId] = useState<string>()
    const [assignTripReservationId, setAssignTripReservationId] = useState<string[]>([])
    const [assignTripTourId, setAssignTripTourId] = useState<string>()
    const [traspassTripReservationId, setTraspassTripReservationId] = useState<string[]>([])
    const [traspassTripTourId, setTraspassTripTourId] = useState<string>()
    const [registerPassengersTripId, setRegisterPassengersTripId] = useState<string>()
    const [registerCostsTripId, setRegisterCostsTripId] = useState<string>()
    const [requirementsTripId, setRequirementsTripId] = useState<string>()
    const [accountingSellerId, setAccountingSellerId] = useState<string>()
    // edit
    const [editTripId, setEditTripId] = useState<string>()
    const [editReservationId, setEditReservationId] = useState<string>()
    const [editPassengerReservationId, setEditPassengerReservationId] = useState<string>()
    const [editPassengerData, setEditPassengerData] = useState<Partial<Passenger>>()
    const [editDriverData, setEditDriverData] = useState<Partial<Driver>>()
    const [editCarData, setEditCarData] = useState<Partial<Car>>()
    const [editGuiderData, setEditGuiderData] = useState<Partial<Guider>>()
    const [editSellerData, setEditSellerData] = useState<Partial<Seller>>()
    const [editAdminData, setEditAdminData] = useState<Partial<Admin>>()
    const [editAgencyData, setEditAgencyData] = useState<Partial<Agency>>()
    const [editCostData, setEditCostData] = useState<Partial<Cost>>()
    const [addPaymentData, setAddPaymentData] = useState<Partial<Payment>>()
    const [editTourInfoId, setEditTourInfoId] = useState<string>()
    const [createBlogTourId, setCreateBlogTourId] = useState<string>()
    const [editZoneId, setEditZoneId] = useState<string>()
    const [groupDetails, setGroupDetails] = useState<Reservation[]>()
    const [listBlogsTourId, setListBlogsTourId] = useState<string>()
    const [editBlog, setEditBlog] = useState<Blog>()
    const [editPaymentData, setEditPaymentData] = useState<Payment>()
    const [editPaymentReservationData, setEditPaymentReservationData] = useState<ReservationPayment>()
    const [editDailyCostData, setEditDailyCostData] = useState<DailyCost>()
    // confirm delete
    const [confirmDeleteCarId, setConfirmDeleteCarId] = useState<string>()
    const [confirmDeleteTripId, setConfirmDeleteTripId] = useState<string>()
    const [confirmDeleteReservationId, setConfirmDeleteReservationId] = useState<string>()
    const [confirmUnassignReservationId, setConfirmUnassignReservationId] = useState<string>()
    const [confirmDeleteCostId, setConfirmDeleteCostId] = useState<string>()
    const [confirmDeletePaymentId, setConfirmDeletePaymentId] = useState<string>()
    const [confirmDeletePassengerId, setConfirmDeletePassengerId] = useState<string>()

    const [currentDay, setCurrentDay] = useState<Date>(startOfToday())
    const [endDay, setEndDay] = useState<Date>()
    // add token to class object
    user?.token && AdminService.setToken(user.token)

    return <AdminProvider.Provider value={
        {
            user, setUser,
            tab, setTab,
            isCreateTourModalOpen, setIsCreateTourModalOpen,
            tourInfoId, setTourInfoId,
            isCreatePassengerModalOpen, setIsCreatePassengerModalOpen,
            isCreateAgencyModalOpen, setIsCreateAgencyModalOpen,
            isCreateSellerModalOpen, setIsCreateSellerModalOpen,
            isCreateAdminModalOpen, setIsCreateAdminModalOpen,
            isCreateDriverModalOpen, setIsCreateDriverModalOpen,
            isCreateGuiderModalOpen, setIsCreateGuiderModalOpen,
            passengerPlanId, setPassengerPlanId,
            currentDay, setCurrentDay,
            endDay, setEndDay,
            assignTripReservationId, setAssignTripReservationId,
            assignTripTourId, setAssignTripTourId,
            traspassTripReservationId, setTraspassTripReservationId,
            traspassTripTourId, setTraspassTripTourId,
            registerPassengersTripId, setRegisterPassengersTripId,
            registerCostsTripId, setRegisterCostsTripId,
            requirementsTripId, setRequirementsTripId,
            accountingSellerId, setAccountingSellerId,
            editTripId, setEditTripId,
            relationshipAgencyId, setRelationshipAgencyId,
            editReservationId, setEditReservationId,
            editPassengerData, setEditPassengerData,
            editTourData, setEditTourData,
            editDriverData, setEditDriverData,
            editGuiderData, setEditGuiderData,
            editSellerData, setEditSellerData,
            editAdminData, setEditAdminData,
            editAgencyData, setEditAgencyData,
            addPaymentData, setAddPaymentData,
            reservationDetails, setReservationDetails,
            viewPaymentAgencyId, setViewPaymentAgencyId,
            editTourInfoId, setEditTourInfoId,
            createBlogTourId, setCreateBlogTourId,
            isCreateZoneModalOpen, setIsCreateZoneModalOpen,
            editZoneId, setEditZoneId,
            groupDetails, setGroupDetails,
            listBlogsTourId, setListBlogsTourId,
            editBlog, setEditBlog,
            confirmDeleteTourId, setConfirmDeleteTourId,
            confirmDeleteAgencyId, setConfirmDeleteAgencyId,
            isCreateCarModalOpen, setIsCreateCarModalOpen,
            editCarData, setEditCarData,
            confirmDeleteCarId, setConfirmDeleteCarId,
            confirmDeleteTripId, setConfirmDeleteTripId,
            confirmDeleteReservationId, setConfirmDeleteReservationId,
            confirmUnassignReservationId, setConfirmUnassignReservationId,
            editPassengerReservationId, setEditPassengerReservationId,
            createPaymentReservationId, setCreatePaymentReservationId,
            isCreateCostModalOpen, setIsCreateCostModalOpen,
            editCostData, setEditCostData,
            confirmDeleteCostId, setConfirmDeleteCostId,
            editPaymentData, setEditPaymentData,
            confirmDeletePaymentId, setConfirmDeletePaymentId,
            isCreatePaymentReservationModalOpen, setIsCreatePaymentReservationModalOpen,
            viewPaymentsData, setViewPaymentsData,
            createPaymentResId, setCreatePaymentResId,
            reservationData, setReservationData,
            editPaymentReservationData, setEditPaymentReservationData,
            isCreateDailyCostModalOpen, setIsCreateDailyCostModalOpen,
            isListDailyCostsModalOpen, setIsListDailyCostsModalOpen,
            editDailyCostData, setEditDailyCostData,
            viewPaymentTraspassData, setViewPaymentTraspassData,
            confirmDeletePassengerId, setConfirmDeletePassengerId,
            createPaymentGroupId, setCreatePaymentGroupId,
        }
    }>{children}</AdminProvider.Provider>;
}

export const useAdmin = () => {
    return useContext(AdminProvider)
}